import { WithUserNamespace } from '../../state/user';
import { getLoggedInUser } from './getLoggedInUser';

export const getUserFirstName = (state: WithUserNamespace) =>
    getLoggedInUser(state)?.firstName || '';
